export const REVIEW_ARTIFACT_COLLECTIONS = Object.freeze({
  DAILY_LOGS: 'dailyLogs',
  KNOWLEDGE_ITEMS: 'knowledgeItems',
});
